import { useEffect, useRef } from "react";
import "grapesjs/dist/css/grapes.min.css";
import { usePageBuilder } from "../hooks";
import { initEditor } from "./initEditor";
import { loadTemplate } from "./loadTemplate";
import { useProject } from "../../project/context/ProjectContext";

export function PageBuilderCanvas() {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const { editorRef, setReady, isReady } = usePageBuilder();

  const { activeTemplateId } = useProject();

  const isInitializingRef = useRef(false);

  useEffect(() => {
    if (!containerRef.current || editorRef.current || isInitializingRef.current) return;

    isInitializingRef.current = true;
    let destroyed = false;

    (async () => {
      const editor = await initEditor(containerRef.current!);
      if (destroyed) {
        editor.destroy();
        return;
      }

      editorRef.current = editor;
      setReady(true);
    })().catch((e) => console.error("INIT ERROR:", e));

    return () => {
      destroyed = true;
      setReady(false);
      if (editorRef.current) {
        editorRef.current.destroy();
        editorRef.current = null;
      }
    };

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const editor = editorRef.current;
    if (!isReady || !editor) return;

    loadTemplate(editor, activeTemplateId);

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady, activeTemplateId]);

  return (
    <div
      ref={containerRef}
      style={{ width: "100%", height: "100%", position: "relative" }}
    />
  );
}
